import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@seeqdev/qomponents';
import utilities from '@/core/utilities';
import { successToast } from '@/utilities/toast.utilities';

export const CopyBranchCode: React.FunctionComponent<{
  text: string;
  branchCode: string;
}> = ({ text, branchCode }) => {
  const { t } = useTranslation();

  const copyBranchCodeToClipboard = async (code: string) => {
    if (!code) return;

    try {
      utilities.copyTextToClipboard(code);
      successToast({
        messageKey: 'HOME_SCREEN.TRAINING.COPY_BRANCH_CODE_SUCCESS',
        messageParams: { branchCode: code },
      });
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <>
      <span>{t(text)}</span>
      <span className="branchCodeHighlighting">{branchCode}</span>
      <Button
        tooltip={t('HOME_SCREEN.TRAINING.COPY_BRANCH_CODE_TOOLTIP')}
        icon="fa-copy"
        iconStyle="text"
        variant="no-border"
        extraClassNames="sq-light-gray"
        testId="copyBranchCodeButton"
        onClick={() => copyBranchCodeToClipboard(branchCode)}
      />
    </>
  );
};
